import { render, staticRenderFns } from "./Edit-ponto-atendimento.vue?vue&type=template&id=423718e4&"
import script from "./Edit-ponto-atendimento.vue?vue&type=script&lang=js&"
export * from "./Edit-ponto-atendimento.vue?vue&type=script&lang=js&"
import style0 from "./Edit-ponto-atendimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports